<template>
  <div class="field-help-content">
    <div v-if="content.description" class="field-help__rich" v-html="content.description"></div>
    <div v-if="content.example" class="field-help__example">
      <div class="field-help__section-title">Exemple</div>
      <div class="field-help__example-text">{{ content.example }}</div>
    </div>
    <div v-if="content.instructions" class="field-help__instructions">
      <div class="field-help__section-title">Consignes</div>
      <div class="field-help__rich" v-html="content.instructions"></div>
    </div>
    <p v-if="!content.hasContent" class="field-help-content__empty">L’aide de ce champ n’est pas renseignée.</p>
  </div>
</template>

<script>
import { normalizeFieldHelp } from './helpContent'

export default {
  name: 'FieldHelpContent',
  props: { help: { type: Object, default: null } },
  computed: { content() { return normalizeFieldHelp(this.help) } },
}
</script>

<style scoped>
.field-help-content { font-size: 13px; line-height: 1.55; overflow-wrap: anywhere; }
.field-help-content__empty { color: var(--app-chat-muted, #737b89); }
.field-help__section-title { margin-bottom: 4px; font-size: 12px; font-weight: 600; }
.field-help__example { margin-top: 12px; padding: 10px 12px; border-radius: 6px; background: rgba(127, 127, 127, .08); }
.field-help__example-text { white-space: pre-wrap; }
.field-help__instructions { margin-top: 12px; }
.field-help__rich ::v-deep > :first-child { margin-top: 0; }
.field-help__rich ::v-deep > :last-child { margin-bottom: 0; }
.field-help__rich ::v-deep p { margin-bottom: 8px; }
.field-help__rich ::v-deep ul, .field-help__rich ::v-deep ol { padding-left: 20px; margin-bottom: 8px; }
.field-help__rich ::v-deep table { border-collapse: collapse; max-width: 100%; }
.field-help__rich ::v-deep th, .field-help__rich ::v-deep td { border: 1px solid rgba(127, 127, 127, .25); padding: 4px 6px; }
.field-help__rich ::v-deep pre { white-space: pre-wrap; }
.field-help__rich ::v-deep blockquote { border-left: 2px solid rgba(127, 127, 127, .3); margin-left: 0; padding-left: 10px; }
</style>
